"use strict";
'use es6'; // Prevent unwanted focus styles

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

require("../listeners/focusStylesListener");

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _CheckboxConstants = require("./CheckboxConstants");

var _Functions = require("../core/Functions");

var _underscore = require("../utils/underscore");

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _FieldsetContext = require("../context/FieldsetContext");

var renderIndicator = (0, _memoize.default)(function (color) {
  return _react.default.createElement("span", {
    className: "private-checkbox__indicator private-radio__indicator",
    style: {
      color: color
    }
  }, _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, _react.default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "10",
    className: "private-radio__circle",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), _react.default.createElement("circle", {
    className: "private-radio__dot",
    id: "a",
    cx: "10",
    cy: "10",
    r: "5"
  }))));
});

var _default = _react.default.createClass({
  displayName: "UIRadioInput",
  propTypes: {
    alignment: _react.PropTypes.oneOf(Object.keys(_CheckboxConstants.ALIGNMENT_CLASSES)),
    'aria-labelledby': _react.PropTypes.string,
    checked: _react.PropTypes.bool,
    children: _react.PropTypes.node,
    color: _react.PropTypes.string,
    defaultChecked: _react.PropTypes.bool,
    description: _react.PropTypes.node,
    descriptionLayout: _react.PropTypes.oneOf(['horizontal', 'vertical']),
    disabled: _react.PropTypes.bool,
    inline: _react.PropTypes.bool,
    labelClassName: _react.PropTypes.string,
    name: _react.PropTypes.string,
    onChange: _react.PropTypes.func,
    readOnly: _react.PropTypes.bool,
    size: _react.PropTypes.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm']), _react.PropTypes.oneOf(['default'])]),
    text: _react.PropTypes.node,
    value: _react.PropTypes.any
  },
  getDefaultProps: function getDefaultProps() {
    return {
      alignment: 'start',
      descriptionLayout: 'vertical'
    };
  },
  handleChange: function handleChange(event) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        onChange = _this$props.onChange,
        readOnly = _this$props.readOnly;

    if (disabled || readOnly) {
      event.preventDefault();
      return;
    }

    (0, _Functions.callIfPossible)(onChange, event);
  },
  render: function render() {
    var _this = this;

    var _this$props2 = this.props,
        alignment = _this$props2.alignment,
        ariaLabelledBy = _this$props2['aria-labelledby'],
        checked = _this$props2.checked,
        children = _this$props2.children,
        className = _this$props2.className,
        color = _this$props2.color,
        defaultChecked = _this$props2.defaultChecked,
        description = _this$props2.description,
        descriptionLayout = _this$props2.descriptionLayout,
        disabled = _this$props2.disabled,
        id = _this$props2.id,
        inline = _this$props2.inline,
        labelClassName = _this$props2.labelClassName,
        name = _this$props2.name,
        __onChange = _this$props2.onChange,
        readOnly = _this$props2.readOnly,
        size = _this$props2.size,
        text = _this$props2.text,
        value = _this$props2.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["alignment", "aria-labelledby", "checked", "children", "className", "color", "defaultChecked", "description", "descriptionLayout", "disabled", "id", "inline", "labelClassName", "name", "onChange", "readOnly", "size", "text", "value"]);

    if (children && text) {
      _devLogger.default.warn({
        message: 'UIRadioInput: `children` or `text` should be specified, not both.',
        key: 'UIRadioInput: children and text given'
      });
    }

    var computedText = children || text;
    var computedDescId = description ? (0, _underscore.uniqueId)('checkbox-') : null;

    if (!name) {
      _devLogger.default.warn({
        message: 'UIRadioInput: `name` must be specified.',
        key: 'UIRadioInput: no name'
      });
    }

    return _react.default.createElement(_FieldsetContext.Consumer, null, function (_ref) {
      var fieldSize = _ref.size,
          fieldDisabled = _ref.disabled;
      var longhandSize = (0, _tshirtSize.toLonghandSize)(size || fieldSize);
      var computedDisabled = disabled || fieldDisabled;
      return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
        className: (0, _classNames.default)('private-radio', className, _CheckboxConstants.ALIGNMENT_CLASSES[alignment], _CheckboxConstants.SIZE_OPTIONS[longhandSize], {
          'private-checkbox': computedText,
          'private-checkbox--disabled': computedDisabled,
          'private-checkbox--readonly': readOnly,
          'private-checkbox--inline': inline,
          'private-checkbox--flush': !computedText,
          'private-checkbox--stack-contents': description && descriptionLayout === 'vertical'
        })
      }), _react.default.createElement("label", {
        className: (0, _classNames.default)('private-checkbox__label', labelClassName)
      }, _react.default.createElement("span", {
        className: "private-checkbox__inner"
      }, _react.default.createElement("input", {
        "aria-describedby": computedDescId,
        "aria-labelledby": ariaLabelledBy,
        checked: checked,
        className: (0, _classNames.default)('sr-only', 'private-checkbox__input'),
        defaultChecked: defaultChecked,
        disabled: computedDisabled,
        id: id,
        name: name,
        onChange: _this.handleChange,
        readOnly: readOnly,
        type: "radio",
        value: value
      }), renderIndicator(color), computedText ? _react.default.createElement("span", {
        className: (0, _classNames.default)('private-checkbox__text', {
          'private-checkbox__text--small': longhandSize === 'small'
        })
      }, computedText) : null)), description && _react.default.createElement("span", {
        className: "private-checkbox__desc",
        id: computedDescId
      }, description));
    });
  }
});

exports.default = _default;
module.exports = exports.default;